// export DsfTextbox from "./textbox.vue";
// export DsfTextarea from "./textarea.vue";
export const DsfTextbox = dsf.defineAsyncComponent("DsfTextbox", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./textbox")
);
export const DsfTextarea = dsf.defineAsyncComponent("DsfTextarea", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./textarea")
);

export const DsfAutoComplete = dsf.defineAsyncComponent("DsfAutoComplete", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./autoComplete")
);

export const DsfNumeration = dsf.defineAsyncComponent("DsfNumeration", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./numeration")
);
export const DsfWangEditor = dsf.defineAsyncComponent("DsfWangEditor", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./neweditor.vue")
);
export const DsfCodeEditor = dsf.defineAsyncComponent("DsfCodeEditor", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./codeEditor.vue")
);
export const DsfUEditor = dsf.defineAsyncComponent("DsfUEditor", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./ueditor.vue")
);
export const DsfCarnumber = dsf.defineAsyncComponent("DsfCarnumber", () =>
  import(/*webpackChunkName:"platform_pc_form"*/ "./carNumber.vue")
);

// export const DsfTextbox=Vue.defineAsyncComponent(()=>import("./textbox.vue"))
